// Univerzalni barevny stitek pro stav operativy nebo polozky.
// Mapuje enum hodnoty z backendu na ceske popisky a tailwind tridy.

import { cn } from '@/lib/utils';
import type { StavOperativy, StavPolozky } from '@/types/api';

type Props =
  | { stav: StavOperativy; type: 'operativa' }
  | { stav: StavPolozky; type: 'polozka' };

const OPERATIVA_LABELS: Record<StavOperativy, string> = {
  NAVRH: 'Návrh',
  KE_SCHVALENI: 'Ke schválení',
  SCHVALENO: 'Schváleno',
  V_REALIZACI: 'V realizaci',
  UPRAVENA: 'Upravená',
  UZAVRENO: 'Uzavřeno',
};

const POLOZKA_LABELS: Record<StavPolozky, string> = {
  NAPLANOVANO: 'Naplánováno',
  PROVEDENO: 'Provedeno',
  PROVEDENO_CASTECNE: 'Provedeno částečně',
  NEPROVEDENO: 'Neprovedeno',
};

// Vsechny tailwind tridy jsou explicitne vypsane, aby je purge tailwindu
// neodriznul (kdyz je sestavujeme dynamicky pres template string, purge je
// nepozna).
const OPERATIVA_STYLES: Record<StavOperativy, string> = {
  NAVRH: 'bg-slate-200 text-slate-700',
  KE_SCHVALENI: 'bg-amber-100 text-amber-800',
  SCHVALENO: 'bg-blue-100 text-blue-800',
  V_REALIZACI: 'bg-emerald-100 text-emerald-800',
  UPRAVENA: 'bg-orange-100 text-orange-800',
  UZAVRENO: 'bg-slate-700 text-slate-50',
};

const POLOZKA_STYLES: Record<StavPolozky, string> = {
  NAPLANOVANO: 'bg-slate-200 text-slate-700',
  PROVEDENO: 'bg-emerald-100 text-emerald-800',
  PROVEDENO_CASTECNE: 'bg-orange-100 text-orange-800',
  NEPROVEDENO: 'bg-red-100 text-red-800',
};

export function StavBadge(props: Props) {
  const label =
    props.type === 'operativa'
      ? OPERATIVA_LABELS[props.stav]
      : POLOZKA_LABELS[props.stav];
  const style =
    props.type === 'operativa'
      ? OPERATIVA_STYLES[props.stav]
      : POLOZKA_STYLES[props.stav];

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold',
        style,
      )}
    >
      {label}
    </span>
  );
}
